import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import colors from '@/styles/color.scss';
let default_1 = class default_1 extends Vue {
    dialogVisible;
    isSimilarity;
    isTitle;
    title;
    width;
    height;
    imgWidth;
    imgHeight;
    bgWidth;
    imgList;
    isChecked;
    isCheckedBg;
    isClose;
    loading;
    checkIndex = '';
    isBorder = true;
    activeBorderColor = colors.boardItemHover;
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    changeList = {};
    isChckIndex(val) {
        // if (!val) {
        this.checkIndex = '';
        // }
    }
    get imgStyle() {
        return {
            width: `${Number(this.imgWidth) / 10}rem`,
            height: `${Number(this.imgHeight) / 10}rem`,
        };
    }
    get mainStyle() {
        return {
            width: `${Number(this.width) / 10}rem`,
            height: `${Number(this.height) / 10}rem`,
        };
    }
    get bgWidthStyle() {
        return {
            width: `${Number(this.bgWidth) / 10}rem`,
        };
    }
    isClosed() {
        this.checkIndex = '';
    }
    getDocumentScore(documentScore) {
        return `${(documentScore * 100).toFixed(2)}%`;
    }
    activated() {
        this.checkIndex = '';
    }
    get returnPrivacyMode() {
        return this.privacyMode === 'true' ? 6 : 0;
    }
    changeImg(index, val, i) {
        // 选中状态
        if (this.checkIndex === val.docId) {
            this.checkIndex = '';
            this.$emit('change-list', '');
        }
        else {
            this.checkIndex = val.docId;
            this.$emit('change-list', val);
        }
    }
};
__decorate([
    Prop({ default: false })
], default_1.prototype, "dialogVisible", void 0);
__decorate([
    Prop({ default: false })
], default_1.prototype, "isSimilarity", void 0);
__decorate([
    Prop({ default: true })
], default_1.prototype, "isTitle", void 0);
__decorate([
    Prop()
], default_1.prototype, "title", void 0);
__decorate([
    Prop({ default: '140' })
], default_1.prototype, "width", void 0);
__decorate([
    Prop({ default: '180' })
], default_1.prototype, "height", void 0);
__decorate([
    Prop({ default: '75' })
], default_1.prototype, "imgWidth", void 0);
__decorate([
    Prop({ default: '100' })
], default_1.prototype, "imgHeight", void 0);
__decorate([
    Prop({ default: '120' })
], default_1.prototype, "bgWidth", void 0);
__decorate([
    Prop()
], default_1.prototype, "imgList", void 0);
__decorate([
    Prop()
], default_1.prototype, "isChecked", void 0);
__decorate([
    Prop({ default: true })
], default_1.prototype, "isCheckedBg", void 0);
__decorate([
    Prop({ default: false })
], default_1.prototype, "isClose", void 0);
__decorate([
    Prop({ default: false })
], default_1.prototype, "loading", void 0);
__decorate([
    Watch('isChecked')
], default_1.prototype, "isChckIndex", null);
__decorate([
    Watch('isClose', { deep: true, immediate: true })
], default_1.prototype, "isClosed", null);
default_1 = __decorate([
    Component({
        name: 'dropdown',
        components: { BlurPicture },
        i18n: {
            messages: {
                en: {
                    similarity: 'Similarity',
                    title: 'Associated Target File',
                    noData: 'No Data',
                },
                zh: {
                    similarity: '相似度',
                    title: '关联目标档案',
                    noData: '暂无数据',
                },
            },
        },
    })
], default_1);
export default default_1;
